import React from 'react';
import Accordion from 'components/Accordion';
import Button from 'components/DesignSystem/Button';
import useClearSelection from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useClearSelection';
import useParams from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useParams';
import { useSelector } from 'react-redux';
import { selectMeteorologyAgroWBCultureTriggerRequest } from 'redux/reducers/meteorologyAgroWBCultureReducer';
import Location from './Location';
import Culture from './Culture';
import Emergency from './Emergency';
import Period from './Period';
import Soil from './Soil';
import Group from './Group';

export default function WBCultureControlPanel() {
  const clearSelection = useClearSelection();
  const params = useParams();
  const triggerDisabled = !params;
  const onTriggerClick = useSelector(selectMeteorologyAgroWBCultureTriggerRequest);

  return (
    <div>
      <Accordion defaultActiveKey="0">
        <Group />
        <Location />
        <Culture />
        <Emergency />
        <Period />
        <Soil />
      </Accordion>
      <Button
        className="w-100 mt-5"
        onClick={onTriggerClick}
        disabled={triggerDisabled}
      >
        Realizar consulta
      </Button>
      <Button type="secondary" className="w-100 mt-1" onClick={clearSelection}>
        Limpar filtros
      </Button>
    </div>
  );
}
